import styled from '@emotion/styled'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { ButtonHTMLAttributes } from 'react'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  isSelected?: boolean
}

const WrapperButton = styled.button<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  border-bottom: ${props => (props.isSelected ? '2px solid var(--Wine-Light)' : 'none')};
  background-color: var(--Transparent);
  margin: 0;
  padding: 0 0 24px;
  display: flex;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    svg {
      color: var(--Red-Dark);
    }

    border-color: var(--Red-Dark);
  }

  svg {
    height: 0.7em;
    width: 0.7em;
    cursor: pointer;
    color: var(--Red-Dark);
  }

  label {
    margin: 1px 0 0 8px;
    cursor: pointer;
    text-align: left;
  }
`

export const RadioTab = ({ children, isSelected, ...props }: Props) => (
  <WrapperButton aria-checked={isSelected ? true : undefined} {...props}>
    {isSelected ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label>{children}</label>
  </WrapperButton>
)
